export const config = {
	version: {
		str: '',
		profile: ''
	}
};